module.exports = __webpack_public_path__ + "static/22-e0d18047c112b2f224084620adc03ab4.png";